import { IAutoQuote, IUser, IRentersQuote } from '../../../interfaces';

import getFinalizedQuote, { TGetFinalizedQuote } from './getFinalizedQuote';

export type TQuoteCheckoutHelpers = {
  quote: IAutoQuote | IRentersQuote;
  user?: IUser;
};

export function quoteCheckoutHelpers({ quote, user }: TQuoteCheckoutHelpers) {
  return {
    getFinalizedQuote: ({
      stripeToken,
      email,
      phone_number,
    }: TGetFinalizedQuote) =>
      getFinalizedQuote({ stripeToken, email, phone_number }, { quote, user }),
  };
}
